import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';

export const StyledStack = styled(Stack)({
  minHeight: '100%',
  overflow: 'scroll',
});

export const StyledTicketSection = styled(Stack)({
  paddingTop: 24,
});

export const StyledDivider = styled.hr({
  border: 'none',
  borderTop: `1px solid ${colors.gray[200]}`,
  margin: 0,
  width: '100%',
});

export const StyledDangerZone = styled(Stack)({
  marginTop: 'auto',
  paddingTop: 24,
});
